module.exports = __webpack_public_path__ + "img/Plan 3-1.3282c4a5.jpg";